export type AnimationDirectionType = 'foldingUp' | 'foldingDown' | 'none';

export const AnimationDirection: {UP: AnimationDirectionType, DOWN: AnimationDirectionType, NONE: AnimationDirectionType} = {
  UP: 'foldingUp',
  DOWN: 'foldingDown',
  NONE: 'none',
};
